import { Link, useMatches } from '@tanstack/react-router'
import { useTranslations } from 'gt-react'
import { BookOpen } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { buildRouteIndex, pageForMatches } from '../navigation'
import { HELP_PAGE_LIST } from '../registry'

const ROUTE_INDEX = buildRouteIndex(HELP_PAGE_LIST)

/**
 * Het boekje in de bovenbalk (spec §7.1): de handleidingpagina bij het huidige scherm, anders de
 * inhoudsopgave. Geen zichtbaarheidscontrole: wie een scherm kan openen, heeft zijn module ook.
 */
export function HelpButton() {
  const t = useTranslations()
  const matches = useMatches()
  const target = pageForMatches(
    matches.map((m) => m.fullPath),
    ROUTE_INDEX,
  )
  const icon = <BookOpen className="size-4" />

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label={t('help.button')}
      title={t('help.button')}
      asChild
    >
      {target ? (
        <Link to="/help/$" params={{ _splat: target }}>
          {icon}
        </Link>
      ) : (
        <Link to="/help">{icon}</Link>
      )}
    </Button>
  )
}
